import { render, staticRenderFns } from "./RealisationSidebarPrivateTab.vue?vue&type=template&id=39810a9b"
import script from "./RealisationSidebarPrivateTab.vue?vue&type=script&lang=js"
export * from "./RealisationSidebarPrivateTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports